export const getFullDeliveryAddress = (street: string, city: string) => {
    if (street && city) {
        return `${street}, ${city}`
    } else if (!street) {
        return city
    } else {
        return street
    }
}
